
<template>
  <!-- 目录 isCatalogue == 1 -->
  <el-submenu v-if="item.isCatalogue == 0" :index="item.id">
    <template slot="title">
      <svg style="margin-left: -90px;" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 8C5 6.89543 5.89543 6 7 6H19L24 12H41C42.1046 12 43 12.8954 43 14V40C43 41.1046 42.1046 42 41 42H7C5.89543 42 5 41.1046 5 40V8Z" fill="#51b3f1" stroke="#51b3f1" stroke-width="4" stroke-linejoin="miter"/>
        <path d="M24 20L26.243 24.9128L31.6085 25.5279L27.6292 29.1792L28.7023 34.4721L24 31.816L19.2977 34.4721L20.3708 29.1792L16.3915 25.5279L21.757 24.9128L24 20Z" fill="#FFF" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
      </svg>
      <span @click="handleItemClick(item)">{{ item.wikiName }}</span>
      <el-dropdown trigger="click" @command="handleCommand($event, item)" class="more-actions" :disabled="isView">
        <span class="el-dropdown-link" @click.stop>
          <i class="el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown" style="padding-left: 17px;">
          <el-dropdown-item command="adds">
            <svg style="position: absolute; margin-left: -25px; margin-top: 8px;" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 10L8 13L14 7" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M5 24L8 27L14 21" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M5 38L8 41L14 35" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M21 24H43" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M21 38H43" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M21 10H43" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
            </svg>
            创建目录
          </el-dropdown-item>
          <el-dropdown-item command="add">
            <svg style="position: absolute; margin-left: -25px; margin-top: 8px;" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 44H38C39.1046 44 40 43.1046 40 42V14H30V4H10C8.89543 4 8 4.89543 8 6V42C8 43.1046 8.89543 44 10 44Z" fill="#51b3f1" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M30 4L40 14" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M24 21V35" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M17 28H24L31 28" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
            </svg>
            添加页面
          </el-dropdown-item>
          <el-dropdown-item command="deletes">
            <svg style="position: absolute; margin-left: -25px; margin-top: 8px;" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 8C5 6.89543 5.89543 6 7 6H19L24 12H41C42.1046 12 43 12.8954 43 14V40C43 41.1046 42.1046 42 41 42H7C5.89543 42 5 41.1046 5 40V8Z" fill="#51b3f1" stroke="#51b3f1" stroke-width="4" stroke-linejoin="miter"/>
              <path d="M19 22L29 32" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M29 22L19 32" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
            </svg>
            删除目录
          </el-dropdown-item>
          <el-dropdown-item command="renames">
            <svg style="position: absolute; margin-left: -25px; margin-top: 8px;" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M42 26V40C42 41.1046 41.1046 42 40 42H8C6.89543 42 6 41.1046 6 40V8C6 6.89543 6.89543 6 8 6L22 6" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              <path d="M14 26.7199V34H21.3172L42 13.3081L34.6951 6L14 26.7199Z" fill="#51b3f1" stroke="#51b3f1" stroke-width="4" stroke-linejoin="miter"/></svg>
            重命名
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
    
    <!-- 递归渲染子菜单 -->
    <template v-if="item.children && item.children.length">
      <menu-item
        v-for="(child,index) in item.children"
        :key="child.id"
        :item="child"
        @command="handleCommand"
        @item-click="handleItemClick"
      />
    </template>
  </el-submenu>

  <!-- 内容 isCatalogue == 2 -->
  <el-menu-item v-else-if="item.isCatalogue === 1" :index="item.id" @click="handleItemClick(item)">
    <template slot="title">
      <div class="menu-title" :class="{ 'is-active': activeItemId === item.id }" >
        <svg style="position: absolute; margin-left: -22px;" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M38 4H10C8.89543 4 8 4.89543 8 6V42C8 43.1046 8.89543 44 10 44H38C39.1046 44 40 43.1046 40 42V6C40 4.89543 39.1046 4 38 4Z" fill="#51b3f1" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
          <path d="M17 30L31 30" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
          <path d="M17 36H24" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
          <path d="M30 13L22 21L18 17" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
        </svg>
        <span>{{ item.wikiName }}</span>
        <el-dropdown trigger="click" @command="handleCommand($event, item)" :disabled="isView">
          <span class="el-dropdown-link" @click.stop>
            <i class="el-icon-more new-more" ></i>
          </span>
          <el-dropdown-menu slot="dropdown" style="padding-left: 17px;">
            <el-dropdown-item command="rename">
              <svg style="position: absolute; margin-left: -25px; margin-top: 8px;" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 44H38C39.1046 44 40 43.1046 40 42V14H30V4H10C8.89543 4 8 4.89543 8 6V42C8 43.1046 8.89543 44 10 44Z" fill="#51b3f1" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
                <path d="M30 4L40 14" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
                <path d="M21 35L31 25L27 21L17 31V35H21Z" fill="#FFF" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              </svg>
              重命名
            </el-dropdown-item>
            <el-dropdown-item command="delete">
              <svg style="position: absolute; margin-left: -25px; margin-top: 8px;" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 44H38C39.1046 44 40 43.1046 40 42V14H30V4H10C8.89543 4 8 4.89543 8 6V42C8 43.1046 8.89543 44 10 44Z" fill="#51b3f1" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
                <path d="M30 4L40 14" stroke="#51b3f1" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
                <path d="M17 28H24L31 28" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
              </svg>
              删除
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </template>
  </el-menu-item>
</template>

<script>
export default {
  name: 'MenuItem',
  
  props: {
    item: {
      type: Object,
      required: true
    },
    activeItemId: {
      type: [String, Number],
      default: 1
    }
  },

   data() {
    return {
      isView: false,
    }
  },
  mounted() {

    axios.get(`${apiBaseUrl}/wikiCategory/getUserWikiJur`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
      if (response.data && response.data.code === 200) {
          this.isView = response.data.data ? false : true
      } else {
          this.isView = true
          this.$message.error(response.data.message || response.data.meg);
      }
    }).catch((error) => {
       this.isView = true
       this.$message.error(error);
    });
   
  },
  methods: {

    handleCommand(command, item) {
      this.$emit('command', command, item)
    },

    handleItemClick(item) {
      this.$emit('item-click', item)
    }
  }
}
</script>

<style scoped lang="less">
.menu-title {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.menu-title.is-active {
  color: #409EFF;
}

.more-actions {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.el-dropdown-link {
  cursor: pointer;
  color: #606266;
}

.el-dropdown-link:hover {
  color: #409EFF;
}


.menu-container {
  padding: 0px 10px;
}

.more-actions {
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
}

.el-dropdown-link {
  cursor: pointer;
}

.el-dropdown-link:hover {
  color: #409EFF;
}

.el-menu-item-group__title{
  color: #000 !important;
}

.el-menu-item {
  position: relative;
  margin-left: -37px;
}

.el-submenu__title {
  position: relative;
}


.menu-title {
  position: relative;
  padding: 0 20px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px;
}

.menu-title:hover {
  background-color: #ecf5ff;
}

.menu-title.is-active {
  font-weight: bold;
  padding: 9px 0px;
  margin-right: 5px;
  font-weight: bold;
}


.menu-title.is-active span {
  color: #ffffff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #909399;
  padding: 5px;
  border-radius: 4px;
}

.el-dropdown-link:hover {
  color: #409EFF;
  background-color: #ecf5ff;
}

.menu-title{
    margin-left: 9px;
}

/deep/ .el-menu--inline{
  margin-left: 40px;
}

/deep/ .el-submenu__title{
  text-align: start;
  padding-left: 85px !important;
}

/deep/ .el-dropdown{
    text-align: end;
    position: absolute;
    right: 40px;
}


</style>



// WEBPACK FOOTER //
// src/CKEditor/MenuItem.vue